    <div class="modal-header">
        <h4 class="modal-title">Sager på kunde : {{kunde.glkundenr}} - {{date | date:'dd-MM-yyyy'}}</h4>
        <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
    </div>

    <div class="modal-body">
        <div class="table__viewport">
            <table class="table table-hover table-striped table-sm table-frame__body" >
                <thead class="fixed-top position-fixed position-sticky">
                    <tr>
                        <th colspan="2">Sag</th>
                        <th class="text-nowrap text-end">Realiseret</th>
                        <th class="text-nowrap text-end">Faktureret</th>
                        <th class="text-nowrap text-end">Igangværende</th>
                        <th class="text-nowrap text-end">Forventet tab.</th>
                        <th class="text-nowrap text-end">Reguleringer</th>
                    </tr>
                </thead>

                <tbody>
                <tr *ngFor="let sag of statistikIgangvaerendeKunde$ | async;">
                    <td colspan="2">{{ sag.sagNavn }}</td>
                    <td class="link-td text-end" (click)="openSagskortModal(kunde.kid)">{{sag.realiseret | currency:'DKK':'':'1.0-0':'da'}}</td>
                    <td class="link-td text-end" (click)="openFakturaModal(kunde, sag.sagId)">{{sag.faktureret | currency:'DKK':'':'1.0-0':'da'}}</td>
                    <td class="text-end">{{sag.realiseret - sag.faktureret | currency:'DKK':'':'1.0-0':'da'}}</td>
                    <td class="d-flex align-items-center justify-content-end">
                        <div style="position: relative;">
                            <input type="number" name="" #forventetTabInput value="{{sag.forventedTab || '0'}}"  class="form-control form-control-sm  text-end" (blur)="openDateModal(sag, forventetTabInput.value)">
                            <button type="button" class="btn btn-sm btn-primary ms-2" style="position: absolute; right: -30px; top: 0;" (click)="openRetForventetTabModal(sag.sagId)">
                                <i class="fa-solid fa-pen"></i>
                            </button>
                        </div>
                    </td>
                    <td class="text-end">{{(sag.reguleringer || 0) | currency:'DKK':'':'1.0-0':'da'}}</td>
                </tr>
                <tr>
                    <td colspan="3">Aconto</td>
                    <td class="text-end">{{kunde.aconto | currency:'DKK':'':'1.0-0':'da'}}</td>
                    <td class="text-end">{{-kunde.aconto | currency:'DKK':'':'1.0-0':'da'}}</td>
                    <td></td>
                    <td></td>
                </tr>
                </tbody>

                <tfoot class="fixed-bottom position-fixed position-sticky">
                    <tr>
                        <th>Total</th>
                        <td></td>
                        <td class="text-end">{{kunde.realiseret + kunde.realiseretKr | currency:'DKK':'':'1.0-0':'da'}}</td>
                        <td class="text-end">{{kunde.faktureret + kunde.aconto | currency:'DKK':'':'1.0-0':'da'}}</td>
                        <td class="text-end">{{(kunde.realiseret + kunde.realiseretKr) - (kunde.faktureret + kunde.aconto) | currency:'DKK':'':'1.0-0':'da'}}</td>
                        <td class="text-end">{{statistikIgangvaerendeKunde$ | async | calcTotalForventetTab | currency:'DKK':'':'1.0-0':'da'}}</td>
                        <td class="text-end">{{kunde.regulering | currency:'DKK':'':'1.0-0':'da'}}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
